import { render } from "./WCSelectBoxGroup.vue?vue&type=template&id=da86f654&scoped=true"
import script from "./WCSelectBoxGroup.vue?vue&type=script&lang=js"
export * from "./WCSelectBoxGroup.vue?vue&type=script&lang=js"

import "./WCSelectBoxGroup.vue?vue&type=style&index=0&id=da86f654&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da86f654"]])

export default __exports__